import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificacionComponent } from './notificacion/notificacion.component';
import { BusquedaComponent } from './busqueda/busqueda.component';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { BurbujasComponent } from './burbujas/burbujas.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { RelacionadosComponent } from './relacionados/relacionados.component';
import { VideotutorialesComponent } from './videotutoriales/videotutoriales.component';
import { LoadingComponent } from './loading/loading.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { LinksComponent } from './links/links.component';
import { PipeModule } from '../pipes/pipe.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxHighlightWordsModule } from "ngx-highlight-words";

@NgModule({
    declarations: [NotificacionComponent, BusquedaComponent, BurbujasComponent, SidebarComponent, RelacionadosComponent, VideotutorialesComponent, LoadingComponent, FeedbackComponent, LinksComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PipeModule,
    DragDropModule,
    NgxHighlightWordsModule 
  ],
    exports: [NotificacionComponent, BusquedaComponent, BurbujasComponent, SidebarComponent, RelacionadosComponent, VideotutorialesComponent, FeedbackComponent, LinksComponent]
})
export class ComponentsModule { }
